import { useEffect, useState, useCallback } from 'react';
import { listCierres, listSucursales } from '../services/data';

export function useCuadres({ fecha, sucursalId }) {
  const [cuadres, setCuadres] = useState([]);
  const [sucursalesMap, setSucursalesMap] = useState({});
  const [cajaChicaMap, setCajaChicaMap] = useState({});
  const [sucursalesList, setSucursalesList] = useState([]);

  const obtenerCuadres = useCallback(async () => {
    const filtros = { fecha: fecha || undefined };
    if (sucursalId && sucursalId !== 'all') filtros.sucursalId = sucursalId;
    setCuadres(await listCierres(filtros));
  }, [fecha, sucursalId]);

  useEffect(() => {
    listSucursales().then((rows) => {
      const ubic = {}, caja = {};
      rows.forEach((s) => {
        ubic[s.id] = s.ubicacion || s.nombre || 'Sin lugar';
        caja[s.id] = Number(s.cajaChica) || 0;
      });
      setSucursalesMap(ubic);
      setCajaChicaMap(caja);
      setSucursalesList(rows
        .map((s) => ({ id: s.id, nombre: s.ubicacion || s.nombre || 'Sin nombre' }))
        .sort((a, b) => a.nombre.localeCompare(b.nombre)));
    }).catch(console.error);
  }, []);

  useEffect(() => { obtenerCuadres().catch(console.error); }, [obtenerCuadres]);

  return { cuadres, sucursalesList, sucursalesMap, cajaChicaMap, refetch: obtenerCuadres };
}
